import './Button.scss'

export const BUTTON_EMPHASIS = {
    PRIMARY: 'primary',
    SECONDARY: 'secondary',
}

export default ({
                    className = '',
                    icon,
                    isIconRight = false,
                    isIconOnly = false,
                    isRed = false,
                    isChecked = false,
                    emphasis = BUTTON_EMPHASIS.SECONDARY,
                    children,
                    ...restOfProps
                }) => {
    let iconClass = !!icon ? 'has-icon' : ''
    if (isIconRight) {
        iconClass += ' is-icon-right'
    }
    return (
        <button
            className={`
                button
                emphasis-${emphasis}
                ${iconClass}
                ${className}
                ${isRed ? 'is-red' : ''}
                ${isIconOnly ? 'is-icon-only' : ''}
                ${isChecked ? 'is-checked' : ''}
            `}
            {...restOfProps}
        >
            {!isIconRight && <div className='icon'>{icon}</div>}
            <div className='button-content'>
                {children}
            </div>
            {isIconRight && <div className='icon'>{icon}</div>}
        </button>
    )
}